import { fetchGraphQL, fetchClientGraphQL } from '~/hooks/graphql.js';

const getPageNodeFields = `
  id
  isComment
  isContentNode
  isFrontPage
  isPostsPage
  isTermNode
  uri
  ... on Page {
    authorId
    formattedContent
    contentTypeName
    databaseId
    dateGmt
    featuredImageId
    guid
    id
    isRestricted
    link
    modifiedGmt
    pageId
    slug
    status
    title
    uri
    featuredImage {
      node {
        altText
        mediaItemUrl
      }
    }
    enqueuedStylesheets {
      nodes {
        id
        handle
        src
      }
    }
  }
  ... on Post {
    author {
      node {
        name
        uri
      }
    }
    categories {
      nodes {
        name
        uri
      }
    }
    formattedContent
    contentTypeName
    databaseId
    dateGmt
    featuredImageId
    guid
    id
    isRestricted
    link
    modifiedGmt
    databaseId
    slug
    status
    title
    uri
    enqueuedStylesheets {
      nodes {
        id
        handle
        src
      }
    }
    featuredImage {
      node {
        altText
        mediaItemUrl
      }
    }
  }
`;

const getPageDataQuery = `query PageNodeByUri($uri: String!) {
  nodeByUri(uri: $uri) {
    ${ getPageNodeFields }
  }
}`;

const fetchPageData = (uri) => {
  return fetchGraphQL(getPageDataQuery, { uri });
};

/**
 * Post types: post, page
 *
 * isPreview: - if true, return latest unsaved revision for post
 */
async function fetchPostPreviewById ({ postId, isPreview = false }) {
  return await fetchClientGraphQL(`
    query PostPreview ($postId: Int!, $isPreview: Boolean) {
      postPreview(id: $postId, preview: $isPreview) {
        ${ getPageNodeFields }
      }
    }`,
    { postId, isPreview });
}

export {
  getPageNodeFields,
  getPageDataQuery,
  fetchPageData,
  fetchPostPreviewById,
}